import { combineReducers } from "redux";
import address from "./address";
import banner from "./banner";
import blogcategory from "./blogcategory";
import blogs from "./blogs";
import category from "./category";
import customer from "./customer";
import offer from "./offer";
import orders from "./orders";
import product from "./product";
import review from "./review";
import user from "./user";
import calculation from "./calculation";
import otp from "./otp";
import razorpay from "./razorpay";
import generateToken from "./generateToken";
import login from "./login";
import { LOGOUT_USER } from "../actions/actionTypes";
import contactAs from "./contactAs";
import state from "./state";
import uiReducer from "./ui";
import delhivery from "./delhivery";
import supporttickets from "./supporttickets";

const appReducer = combineReducers({
  address: address,
  banner: banner,
  blogcategory: blogcategory,
  blogs: blogs,
  category: category,
  customer: customer,
  offer: offer,
  state: state,
  orders: orders,
  product: product,
  review: review,
  user: user,
  generateToken: generateToken,
  calculation: calculation,
  otp: otp,
  razorpay: razorpay,
  login: login,
  contactAs: contactAs,
  ui: uiReducer,
  delhivery: delhivery,
  supporttickets: supporttickets,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
